import { render } from "./BrandDruckStyria.vue?vue&type=template&id=1aca11ae"
import script from "./BrandDruckStyria.vue?vue&type=script&lang=ts"
export * from "./BrandDruckStyria.vue?vue&type=script&lang=ts"

import "./BrandDruckStyria.vue?vue&type=style&index=0&id=1aca11ae&lang=scss"
script.render = render

export default script